export default __webpack_public_path__ + "images/credit-cards.e519034b1ab78a76978162aaa82b9b7a.png";